module.exports = __webpack_public_path__ + "static/media/home_meta_US_cover.d44a840b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_meta_US_cover.png
// module id = 201
// module chunks = 0